import { Form } from "react-bootstrap";
import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); 
  gap: 10px; 

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr; 
  }
`;

export const FormGroupCustom = styled(Form.Group)`
  display: flex;
  flex-direction: column; 
  margin: 0px 0px;
`;

export const FormLabelCustom = styled(Form.Label)`
  &:after {
    color: ${({ theme }) => theme.colors.error};
    content: ' *';
    display: ${({ required }) => (required ? 'inline' : 'none')};
  }
`;

export const Chips = styled.div`
  display: 'flex';
  flex-wrap: 'wrap';
`

export const SelectFilter = styled(Form.Select)`
  border: 1.5px solid #e1e6ef;
  border-radius: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 0.3px;
  color: #1e212a;
  height: 44px;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 10px;
  }
`;

export const InputDateInicial = styled.input`
  border: 1.5px solid hsl(0, 0%, 80%);;
  border-radius: 4px;
  padding: 2px 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 0.3px;
  color: #1e212a;
  height: 38px;
  @media screen and (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 10px;
  }
`;

export const InputDateFinal = styled.input`
  border: 1.5px solid hsl(0, 0%, 80%);;
  border-radius: 4px;
  padding: 2px 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 0.3px;
  color: #1e212a;
  height: 38px;
  @media screen and (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 10px;
  }
`;

